"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const BaseRestClient_1 = require("./BaseRestClient");
class BotsRestClient extends BaseRestClient_1.BaseRestClient {
    getBotInfo(botId) {
        const basePath = '/v1/bots/info/';
        const options = {
            eventProperties: {
                genericEventPath: basePath,
            },
        };
        return this.performApiGet(basePath + botId, options);
    }
    addBotToContacts(botId, skypetoken) {
        const basePath = '/v1/bots/add/';
        const options = {
            headers: {
                'X-Skypetoken': skypetoken,
            },
            eventProperties: {
                genericEventPath: basePath,
            },
        };
        return this.performApiPut(basePath + botId, {}, options);
    }
}
exports.default = new BotsRestClient(config_1.default.urls.api.huddle);
